<template>
  <Modal v-model="model" title="客户信息" sticky reset-drag-position @on-cancel="cancel" fullscreen footer-hide scrollable class="search_customer_Info">
    <div class="all_customer_style">
      <div class="fixed_search" :style="searchHeight">
        <Form ref="formValidate" :model="formValidate" class="form_submit_style">
          <FormItem v-show="!typeOfCallPlan">
            <Select v-model="formValidate.customerScope" placeholder="请选择客户范围" class="tab_change_style" @on-change="initSearch()">
              <Option v-for="(option, index) in customerScopeList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
          </FormItem>
          <FormItem v-for="(item,index) in formValidate.searchList" :key="index">
            <Input v-if="item.type=='text'" :title="item.customName" :placeholder="item.customName" v-model="item.customValue"/>

            <el-date-picker  v-model="item.customValue" unlink-panels type="datetimerange" :start-placeholder="'开始'+item.customName" :end-placeholder="'结束'+item.customName"  :title="item.customName" align="left" :default-time="['00:00:00', '23:59:59']"
                             :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss" v-if="item.type=='datetime'"></el-date-picker>

            <Select v-if="item.type=='select' || item.type=='radio'" :placeholder="item.customName" :title="item.customName" clearable  v-model="item.customValue">
              <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
            </Select>

            <Select v-if="item.type=='checkbox'" :placeholder="item.customName" class="multiple_search"  :title="item.customName" clearable multiple :max-tag-count="2" v-model="item.customValue">
              <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
            </Select>

            <el-cascader clearable  v-if="item.type=='cascade'" v-model="item.customValue" :placeholder="item.customName" :title="item.customName" :options="item.list" :props="{ expandTrigger: 'hover' }"></el-cascader>

            <Input v-if="item.type=='number'" type="number" placeholder="只能输入数字" :title="item.customName" v-model="item.customValue"/>
          </FormItem>
          <FormItem class="senior_search fixed_operation_btn">
            <el-popover placement="bottom" width="450" trigger="click" v-if="formValidate.seniorList.length>0" :visible-arrow="visible">
              <div v-for="(item,index) in formValidate.seniorList" :key="index">
                <Input v-if="item.type=='text'" :title="item.customName" :placeholder="item.customName" v-model="item.customValue"/>

                <el-date-picker  v-model="item.customValue" unlink-panels type="datetimerange" :start-placeholder="'开始'+item.customName" :end-placeholder="'结束'+item.customName"  :title="item.customName" align="left" :default-time="['00:00:00', '23:59:59']"
                                 :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss" v-if="item.type=='datetime'"></el-date-picker>

                <Select v-if="item.type=='select' || item.type=='radio'" :placeholder="item.customName" :title="item.customName" clearable  v-model="item.customValue">
                  <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
                </Select>

                <el-cascader clearable  v-if="item.type=='cascade'" v-model="item.customValue" :placeholder="item.customName" :title="item.customName" :options="item.list" :props="{ expandTrigger: 'hover' }"></el-cascader>

                <Select v-if="item.type=='checkbox'" class="multiple_style" :placeholder="item.customName" :title="item.customName" clearable multiple  :max-tag-count="2" v-model="item.customValue">
                  <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
                </Select>

                <Input v-if="item.type=='number'" type="number" placeholder="只能输入数字" :title="item.customName" v-model="item.customValue"/>
              </div>
              <el-button slot="reference"><div class="btn_font_search">高级搜索</div></el-button>
            </el-popover>
            <Button type="primary" class="search_btn" style="margin-left: 10px"  @click="initSearch()">查询</Button>
            <Button type="primary" style="margin-left: 10px" class="search_btn reset_btn"  @click="handleReset()">重置</Button>
          </FormItem>
        </Form>
      </div>
      <div class="public_btn" v-if="isShowCheck">
        <Button v-show="isShowCheck" class="search_btn template_btn" style="margin-left: 10px"  @click="importOfSearch('1')">按搜索结果导入</Button>
        <Button v-show="isShowCheck" class="search_btn template_btn" style="margin-left: 10px"  @click="importOfSearch('2')">按选中结果导入</Button>
      </div>
      <div class="public_btn" v-if="typeOfCallPlan">
        <Button v-show="typeOfCallPlan && roleList['2_2-8']" class="search_btn template_btn" style="margin-left: 10px"  @click="addNewTask('2')">新建呼出任务</Button>
        <Button v-show="typeOfCallPlan && roleList['2_2-9']" class="search_btn template_btn" style="margin-left: 10px"  @click="exportTask('外呼任务=>导出','2_2-9')">导出</Button>
      </div>

      <div class="fixed_table">
        <Spin size="large" fix v-if="spinShow"> <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>{{showTips}}</div></Spin>
        <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" :class="{'tableClass':tableClass}" stripe ref="selection" @cell-click="openCallInfo" :cell-class-name="showColorInfo" @selection-change="getSelectedIdForPlan"  @row-dblclick="getSelectedId">
          <el-table-column type="selection" width="50" align="center" v-if="!selectionFlag"> </el-table-column>
          <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :key="index" :fixed="item.fixed"  :prop="item.key" :label="item.title" :width="item.width">
            <template slot="header" slot-scope="scope">
              <el-tooltip  placement="top">
                <span style="overflow:hidden;text-overflow:ellipsis;white-space: nowrap;width: 100%;display: block;">{{item.title}}</span>
                <div slot="content" >
                  <span>{{item.title}}</span>
                </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope" >
              <!-- 附件 -->
              <el-tooltip placement="top" effect="light" v-if="item.key != undefined && item.key.indexOf('file') != -1 && scope.row[item.key] != '' && scope.row[item.key] != undefined">

                <span style="color: #2d8cf0;" v-show="JSON.parse(scope.row[item.key]).length > 0">共{{JSON.parse(scope.row[item.key]).length}}个附件</span>
                <div slot="content">
                  <p v-for="(fileItem,fileIndex) in JSON.parse(scope.row[item.key])" :key="fileIndex">
                    <a style="font-size:14px;color: blue;" :href="baseURL+'common/downloadFile.json?type=0&addr='+fileItem.downloadAddr">附件{{fileIndex+1}}：{{fileItem.description}}</a>
                  </p>
                </div>
              </el-tooltip>

              <!-- 其他 -->
              <span v-else>{{scope.row[item.key]}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page_style">
        <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
        <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
      </div>
      <publicDialerPage  @closePublicDialerPage="closePublicDialerPage" :showPublicDialer="showPublicDialer"  :callUpPhone="callUpPhone" ></publicDialerPage>
      <PublicSendMessage  @closeSendMessage="closeSendMessage" :showSendMessage="showSendMessage"  :callUpPhone="callUpPhone" ></PublicSendMessage>
      <excelExportPop @closeExcelExport="closeExcelExport" :showExcelExport="showExcelExport"  :exportSign="exportSign" :publicTitle="exportTitle"></excelExportPop>
      <ADDAutoAndManual :aiAutoCall="false" :autoObj="autoObj" :showTwoCall="showAddTask" :manualParamsObj="paramsObj" :total="total+''" :isCall="isWhichCall" callId=""  @closeCallEditPop="closeCallEditPop" ></ADDAutoAndManual>
    </div>
  </Modal>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import publicDialerPage from '@/components/login/PublicDialerPage.vue'
  import PublicSendMessage from '@/components/login/PublicSendMessage.vue'
  import excelExportPop from '@/components/customerMange/ExcelExportPop.vue'
  import {customerPublicBtn} from '@/components/js/CustomerPublicBtn.js'
  import ADDAutoAndManual from '@/components/callManage/ADDAutoAndManual.vue'
  export default {
    name: "SearchCustomerInfoPop",
    mixins:[publicFunClass,customerPublicBtn],
    components:{
      publicDialerPage,
      PublicSendMessage,
      excelExportPop,
      ADDAutoAndManual,
    },
    props: {
      showCustomerInfo:Boolean,
      isCallPlan:Boolean,
      selectCallId:String,
      taskTypeForCust:String,
      typeOfCallPlan:String,
      autoObj:Object,
      selectionFlag: Boolean
    },
    data(){
      return {
        model:false,
        customerId:'',
        customerName:'',
        formValidate:{"customerScope":"1","customerState":"0","searchList":[],"seniorList":[],"allColumnInfo":[]},
        searchId: '',
        searchHeight:{'height':''},
        spinShow: true,
        tableClass: true,
        visible: true,
        tableHeight:600,
        customerScopeList: [{'id': '0', 'name': '我的客户'}, {'id': '1', 'name': '全部客户'}],
        checkedAll: false,
        total: 0,
        uploadSign: "0",
        pageSizeList: [10, 20, 30, 40, 50, 100, 200],
        roleList: JSON.parse(localStorage.getItem("roleList")),
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        currentPage: 1,
        speedChangePage: 1,
        pageSize: 20,
        singleCheckedList: [],
        fieldList: [],
        contentList: [],
        isShowCheck:false,
        checkIds:[],
        showCustomeOfCall:false,
        showTips:'正在加载中...',
        editable:false,
        exportTitle:'导出外呼任务客户',
        exportSign:'taskCustom',
        showExcelExport:false,
        showAddTask:false,
        paramsObj:{},
        showAutoOutCall:false,
        isWhichCall:'',
        queryParam:null,
      }
    },
    methods:{
      //导出外呼任务
      exportTask:function(journalType,menuId){
        this.journalType=journalType;
        this.menuId=menuId;
        this.showExcelExport=true;
        let value = this.typeOfCallPlan;
        if(value){
          value = value.split(",")[0];
        }
        let type = "";
        if(value == '1'){
          type = '1';
        }else{
          type = '2';
        }
        this.paramDate = {
          taskId:this.selectCallId,
          taskType:type
        };
      },
      closeCallEditPop:function(flag){
        this.showAddTask=false;
        this.showAutoOutCall=false;
        if(flag){
          this.$emit("closeCustomerInfo",true);
        }
      },
      //新建呼出任务
      addNewTask:function(){
        let value = this.typeOfCallPlan;
        if(value){
          value = value.split(",")[0];
        }
        let listForCall = this.typeOfCallPlan;
        let newList = listForCall.split(",");
        let param={};
        if("1"==newList[0]){
          param={
            pageNum:this.currentPage,
            pageSize:this.pageSize,
            journalType:"null",
            menuId:"null",
            taskId:this.selectCallId,
            taskType:newList[0],
            calloutState:newList[1],
            selectIds:this.checkIds
          }
        }else{
          param={
            journalType:"null",
            menuId:"null",
            taskId:this.selectCallId,
            taskType:newList[0],
            calloutState:newList[1],
            selectIds:this.checkIds
          }
        }
        this.getParam(this.formValidate,param);
        this.paramsObj = param;
        if(value == '1'){
          this.isWhichCall = '1';
        }else{
          this.isWhichCall = '2';
        }
        this.showAddTask=true;
      },
      openCallInfo:function(row, column){
        if(this.typeOfCallPlan!=undefined && this.typeOfCallPlan!='2,'){
          this.openPopTelScreen(row, column);
        }
      },
      showColorInfo:function(event){
        if(this.typeOfCallPlan!=undefined && this.typeOfCallPlan!='2,'){
          return this.returnClassName(event);
        }
      },
      cancel:function(){
        this.$emit("closeCustomerInfo",false);
      },
      getSelectedId:function (selection) {
        //如果是呼出计划进来的则不允许双击关闭
        if(!this.isShowCheck && !this.showCustomeOfCall){
          this.$emit("closeCustomerInfo",true,selection);
        }
      },
      getSelectedIdForPlan:function(selection){
        this.checkIds=[];
        for (let i=0;i<selection.length;i++){
          this.checkIds.push(selection[i].id)
        }
      },
      initSearch:function () {
        //判断是否从呼出查看客户进入
        if(this.typeOfCallPlan){
          this.initTable();
          return;
        }
        this.spinShow=true;
        let selectCount=false;
        let list=this.formValidate.searchList;
        for (let i=0;i<list.length;i++){
          let customValue=list[i].customValue;
          if(customValue){
            selectCount=true;
          }
        }
        let param={
          pageNum:this.currentPage,
          pageSize:this.pageSize,
          journalType:"null",
          menuId:"null",
          customerType: this.customerType,
          selectCount:selectCount,
          customerScope:this.formValidate.customerScope,
          customerState:this.formValidate.customerState
        };
        let url = 'customer/selectAllCustomer.json';
        this.publicFunction(url,param);
      },
      initTable:function(){
        this.spinShow=true;
        let selectCount=false;
        let list=this.formValidate.searchList;
        for (let i=0;i<list.length;i++){
          let customValue=list[i].customValue;
          if(customValue){
            selectCount=true;
          }
        }
        let listForCall = this.typeOfCallPlan;
        let newList = listForCall.split(",");
        let param={};
        if("1"==newList[0]){
          param={
            pageNum:this.currentPage,
            pageSize:this.pageSize,
            journalType:"null",
            menuId:"null",
            taskId:this.selectCallId,
            taskType:newList[0],
            calloutState:newList[1],
          }
        }else{
          param={
            pageNum:this.currentPage,
            pageSize:this.pageSize,
            journalType:"null",
            menuId:"null",
            taskId:this.selectCallId,
            taskType:newList[0],
            calloutState:newList[1],
          }
        }
        let url = 'calltask/getCustomer.json';
        this.publicFunction(url,param);
      },
      publicFunction:function(url,param){
        this.speedChangePage=this.currentPage;
        let phoneIsHide= this.configInfo.phoneIsHide;
        this.getParam(this.formValidate,param);

        this.queryParam = param;
        let that=this;
        this.$http.post(url,param) .then(function (res) {
          let result=res.data.flag;
          that.spinShow=false;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.contentList=res.data.obj.list.content;
          let fieldList=res.data.obj.fields;
          let count=0;
          for (let j=0;j<fieldList.length;j++) {
            let customIsShow=fieldList[j].customIsShow;
            if(customIsShow=='1'){
              count++;
            }
          }
          // 判斷是否是呼出计划进来的
          if(that.isShowCheck){
            that.fieldList=[{type: 'selection', width: 50, fixed: true}];
          }else{
            that.fieldList=[];
          }
          let paramList=[];
          let seniorList=[];
          let allColumnInfo=[];
          let countFix=1;
          that.total=res.data.obj.list.totalSize;
          for (let i=0;i<fieldList.length;i++){
            let customIsSearch=fieldList[i].customIsSearch;
            let customColName=fieldList[i].customColName;
            let customName=fieldList[i].customName;
            let customType=fieldList[i].customType;
            let customIsMust=fieldList[i].customIsMust;
            let customIsShow=fieldList[i].customIsShow;
            let customIsAlter=fieldList[i].customIsAlter;
            if(paramList.length+1>10 && customIsSearch=='1'){
              customIsSearch='2';
            }
            let tableHead={
              title: customName,
              key: customColName,
              height:40
            };

            if(count>10){
              tableHead["width"]="150";
              if(customIsShow=='1' && countFix<5){
                countFix++;
                tableHead["fixed"]=true
              }
            }
            if(customIsShow=='1'){
              that.fieldList.push(tableHead);
              if(customColName.indexOf("telephone")!=-1 || customColName.indexOf("Telephone")!=-1) {
                if (phoneIsHide == '1') {
                  tableHead.key = customColName + "Hide";
                }
              }
              if(customColName.indexOf("telephone")!=-1 && that.configInfo.phoneOwnership=='1'){
                let tableHead1={
                  title: customName+"归属地",
                  key: customColName+"Address",
                  height:40
                };
                if(count>10){
                  tableHead1["width"]="150";
                  if(customIsShow=='1' && countFix<4){
                    countFix++;
                    tableHead1["fixed"]=true
                  }
                }
                that.fieldList.push(tableHead1);
              }
            }
            let columnParam={
              type: customType,
              customColName: customColName,
              customValue:(customType=='cascade' || customType=='datetime')?[]:'',
              popCustomValue:(customType=='cascade' || customType=='datetime')?[]:'',
              checkName:"customValue",
              customIsMust:customIsMust,
              customName:customName,
              customIsSearch:customIsSearch,
              customIsAlter:customIsAlter,
              list:fieldList[i].list,
            };
            allColumnInfo.push(columnParam);
            if(customIsSearch=='1'){
              paramList.push(columnParam);
            }
            if(customIsSearch=='2'){
              seniorList.push(columnParam);
            }
          }
          let searchParam=that.formValidate.searchList;
          for (let i=0;i<paramList.length;i++){
            let colName=paramList[i].customColName;
            for (let j=0;j<searchParam.length;j++){
              let name=searchParam[j].customColName;
              if(colName==name){
                paramList[i].customValue=searchParam[j].customValue
              }
            }
          }
          let seniorParam=that.formValidate.seniorList;
          for (let m=0;m<seniorList.length;m++){
            let colName=seniorList[m].customColName;
            for (let n=0;n<seniorParam.length;n++){
              let name=seniorParam[n].customColName;
              if(colName==name){
                seniorList[m].customValue=seniorParam[n].customValue
              }
            }
          }
          that.formValidate.searchList=paramList;
          that.formValidate.seniorList=seniorList;
          that.formValidate.allColumnInfo=allColumnInfo;
          let length=(paramList.length+1)>6?2:1;
          let height=length*40;
          that.searchHeight.height= height+"px";
          let clientHeight=document.documentElement.clientHeight;
          that.tableHeight=clientHeight-132-height;
          if (that.isShowCheck || that.typeOfCallPlan) {
            that.tableHeight=clientHeight-182-height;
          }
        });
      },
      importOfSearch:function (type) {
        let that =this;
        let param={}
        if(type=='1'){
          if(this.contentList.length==0){
            this.$Modal.info({
              title:'提示',
              content:"当前没有可导入的客户"
            });
            return false;
          }
          if(!this.queryParam){
            this.$Modal.info({
              title:'提示',
              content:"请点击查询后再导入"
            });
            return false;
          }
          delete this.queryParam["pageNum"];
          delete this.queryParam["pageSize"];

          this.$set(this.queryParam, 'journalType', '呼出计划=>按搜索结果导入客户');
          this.$set(this.queryParam, 'menuId', '2_2-5');
          this.$set(this.queryParam, 'source', '1');
          this.$set(this.queryParam, 'taskId', this.selectCallId);
          this.$set(this.queryParam, 'taskType', this.taskTypeForCust);

          param = this.queryParam;
        }else{
          if(this.checkIds.length==0){
            this.$Modal.info({
              title:'提示',
              content:"请选择要导入的客户"
            });
            return false;
          }
          param ={
            id:this.checkIds.toString(),
            journalType:"呼出计划=>按选中结果导入客户",
            menuId:'2_2-5',
            taskId:this.selectCallId,
            taskType:this.taskTypeForCust,
            source:'1'
          };
        }
        this.showTips='导入中，请稍候...';
        this.spinShow=true;
          this.$http.post("calltask/importMobile.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定'
              });
              return false;
            }
            that.$Message.info(res.data.msg);
            that.$emit("closeCustomerInfo",true);
          });
      },
    },
    watch:{
      showCustomerInfo:function () {
        this.model=this.showCustomerInfo;
        this.formValidate.customerScope="1";
        if(this.showCustomerInfo){
          // 从添加服务记录进来，没有多选
          if(!this.selectionFlag){
            this.selectionFlag = false;
          }
          this.formValidate.searchList=[];
          this.formValidate.seniorList="1";
          this.formValidate.allColumnInfo="1";
          if(this.typeOfCallPlan!=''&&this.typeOfCallPlan!=undefined){
            this.initTable();
            this.showCustomeOfCall=true;
            return;
          }
          if(this.isCallPlan){
            this.isShowCheck=this.isCallPlan;
          }
          this.initSearch();
          this.handleScroll();
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/customerMange/SearchCustomerInfoPop.vue